import { useContext } from "react";
import { EndosoContext } from "../../../../context";
import { ServerSideTable } from "../components";

export const BajaEndoso15 = () => {
  const { bajaRiesgo15 } = useContext(EndosoContext);
  if (!bajaRiesgo15) return <></>;
  return <ServerSideTable />;
};
